import React from 'react';
import { TableRow, TableHeader } from '@insurancemenu/imenu-components-lib';
import { TableHeadingStyled } from './styles';

const headings = [
  { title: 'Agency Name' },
  { title: 'Group Name' },
  { title: 'Effective Dates' },
  { title: 'Product Lines' },
  { title: 'Stage' },
  { title: 'AoR Emails' },
  { title: 'Group Admin Emails' },
  { title: '' },
];

const TriggerRenewalsHeader: React.FC = () => {
  return (
    <TableHeader>
      <TableRow>
        {headings.map((headingObj) => (
          <TableHeadingStyled {...headingObj} key={headingObj.title}>
            {headingObj.title}
          </TableHeadingStyled>
        ))}
      </TableRow>
    </TableHeader>
  );
};

export default TriggerRenewalsHeader;
